module.exports = __webpack_public_path__ + "static/media/note.ed4c6a87.png";